/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileType: NonNullable<unknown> }} Editor_Select_Profile_TextInputs */



/**
* | output |
* | --- |
* | "Please select a profile for the {fileType} file" |
*
* @param {Editor_Select_Profile_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_profile_text = /** @type {((inputs: Editor_Select_Profile_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Profile_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Veuillez selectionner un profil pour le fichier ${i?.fileType}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bitte wählen Sie ein Profil für die Datei ${i?.fileType} aus.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Seleziona un profilo per il file ${i?.fileType}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пожалуйста, выберите профиль для файла ${i?.fileType}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Seleccione un perfil para el archivo ${i?.fileType}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`请为 ${i?.fileType} 文件选择一个配置文件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.fileType} ファイルのプロファイルを選択してください`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कृपया ${i?.fileType} फ़ाइल के लिए एक प्रोफ़ाइल चुनें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Selecione um perfil para o arquivo ${i?.fileType}`)
	return /** @type {LocalizedString} */ (`Please select a profile for the ${i?.fileType} file`)
});